import {GlobalVariables} from "../GlobalVariables";
import {ScrollTrigger, gsap} from "../LibrariesImport";
import Lenis from 'lenis';

export default class SmoothScroll {
    constructor() {
        const root = document.documentElement;

        if (ScrollTrigger.isTouch === 1) {
            root.classList.add('touchevents');
        } else {
            root.classList.add('no-touchevents');

            // Lenis désactivé si l'utilisateur préfère le mouvement réduit :
            // le scroll natif reprend, ScrollTrigger continue de fonctionner
            if (!GlobalVariables.reducedMotion) {
                GlobalVariables.lenis = new Lenis({
                    autoRaf: false,
                    lerp: 0.1,
                    wheelMultiplier: 1,
                    anchors: {
                        offset: -100
                    }
                });

                // Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
                GlobalVariables.lenis.on('scroll', ScrollTrigger.update);

                // Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
                // This ensures Lenis's smooth scroll animation updates on each GSAP tick
                gsap.ticker.add((time) => {
                    GlobalVariables.lenis.raf(time * 1000); // Convert time from seconds to milliseconds
                });

                // Disable lag smoothing in GSAP to prevent any delay in scroll animations
                gsap.ticker.lagSmoothing(0);
            }

            // Chaque refresh() recalcule tous les triggers ET force un reflow complet.
            // Les sources de stabilisation ci-dessous (première frame, load, fonts,
            // images) se terminent souvent à quelques ms d'intervalle : sans
            // regroupement, on payait jusqu'à quatre reflows successifs identiques au
            // chargement (33 ms mesurés). On coalesce en un refresh par frame — la
            // dernière mesure de la frame est de toute façon la seule qui compte.
            let refreshQueued = false;
            const scheduleRefresh = () => {
                if (refreshQueued) return;
                refreshQueued = true;
                requestAnimationFrame(() => {
                    refreshQueued = false;
                    ScrollTrigger.refresh();
                });
            };

            // Ensure ScrollTrigger measures correctly when page loads scrolled, bfcache, etc.
            scheduleRefresh();

            window.addEventListener('load', scheduleRefresh);

            window.addEventListener('pageshow', (e) => {
                if (e.persisted) scheduleRefresh();
            });

            // Polices et images chargées après coup = CLS = positions de
            // déclenchement ScrollTrigger obsolètes pour tout ce qui suit dans
            // la page. On reforce un refresh dès que chaque source de décalage
            // est réellement stabilisée, sans attendre le seul event "load".
            document.fonts.ready.then(scheduleRefresh);

            // Filet pour tout autre changement de hauteur de la page après coup. Cas
            // rencontré : $base-font-size dépend du vw, et Chrome n'y reporte la
            // gouttière de scrollbar (scrollbar-gutter: stable, cf. _lenis.scss)
            // qu'au premier scroll. Tout le texte perd alors ~1px par ligne, la page
            // raccourcit, et les data-anim du bas du footer, dont le seuil a été
            // calculé avant, ne se déclenchaient plus (restés en opacity 0). On ne
            // réagit qu'à la hauteur : un refresh() qui la laisse inchangée ne
            // relance donc rien.
            let lastHeight = document.body.offsetHeight;
            new ResizeObserver(() => {
                const height = document.body.offsetHeight;
                if (height === lastHeight) return;
                lastHeight = height;
                scheduleRefresh();
            }).observe(document.body);

            const pendingImages = Array.from(document.images).filter((img) => !img.complete);
            if (pendingImages.length) {
                let remaining = pendingImages.length;
                const onSettle = () => {
                    remaining -= 1;
                    if (remaining === 0) scheduleRefresh();
                };
                pendingImages.forEach((img) => {
                    img.addEventListener('load', onSettle, {once: true});
                    img.addEventListener('error', onSettle, {once: true});
                });
            }
        }
    }
}


